<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import SidebarLayout from '@/layout/SidebarLayout.vue';
import SecurityTrim from '@/components/ui/SecurityTrim.vue';
import CardTable from '@/components/cards/CardTable.vue';
import { AccountActions } from '@/integrations/Immersve/auth/actions';

const route = useRoute();

function queryParam(name: string): string {
  const value = route.query[name];
  return typeof value === 'string' ? value : '';
}

const accountId = computed(() => queryParam('account'));
const seriesId = computed(() => queryParam('series'));
</script>

<template>
  <SidebarLayout>
    <!-- The series is picked out of the account's cards, so it takes
    account:read, as the cards list does. -->
    <SecurityTrim :actions="[AccountActions.Read]" account-id="*">
      <div class="px-4 py-6 md:px-8" data-test="screen-card-series">
        <RouterLink
          v-if="accountId"
          :to="{ path: '/cards', query: { account: accountId } }"
          class="text-sm font-medium text-indigo-600 hover:text-indigo-700"
          data-test="card-series-account-link"
        >
          ← Account's cards
        </RouterLink>
        <h1 class="mt-1 text-2xl font-bold text-gray-900">Card series</h1>
        <p class="mt-1 mb-12 text-sm text-gray-500">
          A card and its reissues, oldest first.
          <span v-if="seriesId" class="font-mono" data-test="card-series-id">{{ seriesId }}</span>
        </p>
        <CardTable v-if="accountId && seriesId" :account-id="accountId" :series-id="seriesId" />
        <p v-else class="text-sm text-gray-500" data-test="card-series-prompt">
          Open a card's series from the Reissue field on its details.
        </p>
      </div>
    </SecurityTrim>
  </SidebarLayout>
</template>
